/**
 * Governance API Client
 * Endpoints for DAO proposal creation, voting, and lifecycle management.
 */
import axios from 'axios';
import { BACKEND_URL } from '@/lib/backendUrl';

const API_BASE = BACKEND_URL || '';

const govApi = axios.create({
  baseURL: `${API_BASE}/api/governance`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

export const getGovernanceConfig = async () => {
  const res = await govApi.get('/config');
  return res.data;
};

export const listProposals = async () => {
  const res = await govApi.get('/proposals');
  return res.data;
};

export const getProposal = async (id) => {
  const res = await govApi.get(`/proposals/${id}`);
  return res.data;
};

export const getVotingPower = async (wallet) => {
  const res = await govApi.get(`/voting-power/${wallet}`);
  return res.data;
};

export const createProposal = async (description, targets, values, calldatas) => {
  const res = await govApi.post('/proposals', { description, targets, values, calldatas });
  return res.data;
};

export const castVote = async (proposalId, voteType) => {
  const res = await govApi.post(`/proposals/${proposalId}/vote`, { vote_type: voteType });
  return res.data;
};

export const queueProposal = async (proposalId) => {
  const res = await govApi.post(`/proposals/${proposalId}/queue`);
  return res.data;
};

export const executeProposal = async (proposalId) => {
  const res = await govApi.post(`/proposals/${proposalId}/execute`);
  return res.data;
};

export const cancelProposal = async (proposalId) => {
  const res = await govApi.post(`/proposals/${proposalId}/cancel`);
  return res.data;
};
